import React, { useState, useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { Routes } from "./routes";

// pages

import Settings from "./components/Settings/Settings";
// components
import Sidebar from "./components/Common/Sidebar";
import Navbar from "./components/Common/Navbar";
import Preloader from "./components/Preloader";
import Users from "./components/Settings/UserComponent";

import Profile from "./components/Profile/Profile";
import Login from "./components/Profile/Login";
import Register from "./components/Profile/Register";
import ForgotPassword from "./components/Profile/ForgotPassword";
import Customers from "./components/Customers/index";

import Services from "./components/Services/index";
import Providers from "./components/Providers/index";
import Metters from "./components/Metters/index";
import CustomerDetails from "./components/Customers/CustomerDetails";

import InventoryPage from "./pages/InventoryPage";
import DashboardPage from "./pages/DashboardPage";
import SalesPage from "./pages/SalesPage";
import SummaryPage from "./pages/SummaryPage";
import DashboardOverview from "./components/dashboard/DashboardOverviewOld";
import ReportsPage from "./pages/ReportsPage";
import SalesRecordPage from "./pages/SalesRecordPage";
import TablePage from "./pages/TablePage";
import FranchisePage from "./pages/FranchisePage";
import ShowcaseDashboard from "./components/dashboard/ShowcaseDashboard";

const RouteWithSidebar = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);
  const [isSidebarOverlay, setIsSidebarOverlay] = useState(() =>
    typeof window === "undefined"
      ? false
      : !window.matchMedia("(min-width: 1200px)").matches
  );
  const [isSidebarOpen, setIsSidebarOpen] = useState(() =>
    typeof window === "undefined"
      ? true
      : window.matchMedia("(min-width: 1200px)").matches
  );

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1200px)");
    const handleBreakpointChange = (event) => {
      setIsSidebarOverlay(!event.matches);
      setIsSidebarOpen(event.matches);
    };

    mediaQuery.addEventListener("change", handleBreakpointChange);
    return () => mediaQuery.removeEventListener("change", handleBreakpointChange);
  }, []);

  useEffect(() => {
    const closeOnEscape = (event) => {
      if (event.key === "Escape" && isSidebarOpen) {
        setIsSidebarOpen(false);
      }
    };

    document.addEventListener("keydown", closeOnEscape);
    document.body.classList.toggle(
      "sidebar-drawer-open",
      isSidebarOverlay && isSidebarOpen
    );

    return () => {
      document.removeEventListener("keydown", closeOnEscape);
      document.body.classList.remove("sidebar-drawer-open");
    };
  }, [isSidebarOpen, isSidebarOverlay]);

  return (
    <Route
      {...rest}
      render={(props) => (
        <div className="app-shell">
          <Preloader show={loaded ? false : true} />
          <Sidebar
            show={isSidebarOpen}
            isOverlay={isSidebarOverlay}
            onClose={() => setIsSidebarOpen(false)}
          />

          <main
            className={`content app-content p-0 ${
              isSidebarOpen ? "sidebar-visible" : ""
            }`}
          >
            <Navbar
              {...props}
              isSidebarOpen={isSidebarOpen}
              onToggleSidebar={() => setIsSidebarOpen((current) => !current)}
            />
            <div className="app-page">
              <Component {...props} />
            </div>
          </main>
        </div>
      )}
    />
  );
};

const App = () => {
  return (
    <Switch>
      {/* Showcase Dashboard - Fullscreen without sidebar */}
      <Route
        exact
        path={Routes.DashboardShowcase.path}
        component={ShowcaseDashboard}
      />
      {/* pages */}
      <RouteWithSidebar
        exact
        path={Routes.Franchise.path}
        component={FranchisePage}
      />
      <RouteWithSidebar
        exact
        path={Routes.SalesRecord.path}
        component={SalesRecordPage}
      />
      <RouteWithSidebar
        exact
        path={Routes.Home.path}
        component={DashboardOverview}
      />
      <RouteWithSidebar exact path={Routes.Sales.path} component={SalesPage} />
      <RouteWithSidebar
        exact
        path={Routes.DashboardSummary.path}
        component={SummaryPage}
      />

      <RouteWithSidebar
        exact
        path={Routes.DashboardPage.path}
        component={DashboardPage}
      />
      <RouteWithSidebar
        exact
        path={Routes.Inventory.path}
        component={InventoryPage}
      />

      <RouteWithSidebar
        exact
        path={Routes.Settings.path}
        component={Settings}
      />

      <RouteWithSidebar exact path={Routes.Users.path} component={Users} />

      <RouteWithSidebar
        exact
        path={Routes.Reports.path}
        component={ReportsPage}
      />
      <RouteWithSidebar
        exact
        path={Routes.Customers.path}
        component={Customers}
      />

      <RouteWithSidebar
        exact
        path={Routes.Services.path}
        component={Services}
      />
      <RouteWithSidebar
        exact
        path={Routes.Providers.path}
        component={Providers}
      />
      <RouteWithSidebar exact path={Routes.Metters.path} component={Metters} />
      <RouteWithSidebar exact path={Routes.Profile.path} component={Profile} />
      <RouteWithSidebar
        exact
        path={Routes.CustomerDetails.path}
        component={CustomerDetails}
      />
      <Route path={Routes.Table.path} component={TablePage} />
      <Route path={Routes.SignIn.path} component={Login} />
      <Route path={Routes.Register.path} component={Register} />
      <Route path={Routes.ForgotPassword.path} component={ForgotPassword} />
      {/* <RouteWithSidebar exact path={Routes.Dashboard.path} component={DashboardOverview} /> */}
      <Redirect to={Routes.NotFound.path} />
    </Switch>
  );
};

export default App;
